import { isBooztmobile } from '@helpers/env';

export const renderImages = () => {
    const lazyImages = document.querySelectorAll('.grid-content--image__image[data-lazy-load]');

    lazyImages.forEach((image) => {
        const el = new Image();
        const src = (isBooztmobile() && image.dataset.srcMobile) ? image.dataset.srcMobile : image.dataset.srcDesktop;

        el.onload = () => {
            image.src = src;
        };

        el.src = src;
    });
};
